import React from 'react';

export const CalculateQuantityIcon: React.FC = () => (
  <svg width="52" height="48" viewBox="0 0 52 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_402_71895)">
      <path d="M2 18L11.2751 18L11.2751 42L2 18Z" fill="#FDC300" />
      <rect
        width="24"
        height="18.7249"
        transform="matrix(1.19249e-08 1 1 -1.19249e-08 11.2751 18)"
        fill="#FDC300"
      />
    </g>
    <path
      d="M26.0069 6.73242L18.4366 14.3027V41.2676H44.9717V6.73242H26.0069Z"
      fill="white"
      stroke="#21282B"
      strokeWidth="1.4645"
    />
    <path
      d="M25.9717 14.0176H18.7217L25.9717 6.76758V14.0176Z"
      fill="#B8CAC4"
      stroke="#21282B"
      strokeWidth="1.4645"
    />
    <rect width="24" height="24" transform="translate(25 18)" fill="white" />
    <rect x="37" y="18" width="12" height="24" fill="#B8CAC4" />
    <rect x="25.7322" y="18.7322" width="22.5355" height="22.5355" stroke="#21282B" strokeWidth="1.4645" />
    <path d="M37 18V42" stroke="#21282B" strokeWidth="1.4645" strokeLinejoin="round" />
    <path d="M37 30L25 30" stroke="#21282B" strokeWidth="1.4645" strokeLinejoin="round" />
    <g clipPath="url(#clip1_402_71895)">
      <path d="M34 24.5L29 24.5" stroke="#21282B" strokeWidth="1.4645" strokeLinejoin="round" />
      <path d="M31.5 22L31.5 27" stroke="#21282B" strokeWidth="1.4645" strokeLinejoin="round" />
    </g>
    <g clipPath="url(#clip2_402_71895)">
      <path d="M34 35.5L29 35.5" stroke="#21282B" strokeWidth="1.4645" strokeLinejoin="round" />
    </g>
    <g clipPath="url(#clip3_402_71895)">
      <path d="M45 28.5417L40 28.5417" stroke="#21282B" strokeWidth="1.4645" strokeLinejoin="round" />
      <path d="M45 31.4582L40 31.4583" stroke="#21282B" strokeWidth="1.4645" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_402_71895">
        <rect width="24" height="28" fill="white" transform="matrix(1.19249e-08 1 1 -1.19249e-08 2 18)" />
      </clipPath>
      <clipPath id="clip1_402_71895">
        <rect width="5" height="5" fill="white" transform="translate(29 22)" />
      </clipPath>
      <clipPath id="clip2_402_71895">
        <rect width="5" height="5" fill="white" transform="translate(29 33)" />
      </clipPath>
      <clipPath id="clip3_402_71895">
        <rect width="5" height="5" fill="white" transform="translate(40 27.5)" />
      </clipPath>
    </defs>
  </svg>
);
